export default {"src":"/_next/static/media/weight-loss-multicoloured.1e234c70.svg","height":55,"width":58,"blurWidth":0,"blurHeight":0};